<div fxFlex="column">
  <p class="title" fxFlexAlign="start start">{{ title }}</p>

  <div class="button-group" fxLayout="row">
    <button *ngFor="let option of display" type="button" [className]="selected == option.value ? 'accent button-meeting' : 'button-meeting'" (click)="changeOption(option.value)">
      {{ option.name | translate }}
    </button>
  </div>
</div>
